<template>
  <ProgramareNouaMobile v-if="is_mobile" />
  <section v-else class="intrare-noua">
    <main class="relative">
      <div v-if="isAutocomplete && $store.getters[activeField] && $store.getters[activeField].length">
        <Autocomplete ref="autocomplete"
                      :name="autocompleteFieldName"
                      :positionY="autocompletePositionY"
                      :positionX="autocompletePositionX"
                      :list="$store.getters[activeField]"
                      @select-item="handleAutocompleteItem"
                      @hide="hideAutocomplete" />
      </div>

      <ValidationObserver ref="observer">
        <div v-if="$router.currentRoute.params.id"
             class="top-actions">
          <router-link cy="comanda-btn"
                       :to="'/comanda/' + $router.currentRoute.params.id">
            <button>COMANDĂ</button>
          </router-link>
          <router-link cy="deviz-btn"
                       :to="'/deviz/' + $router.currentRoute.params.id">
            <button>DEVIZ</button>
          </router-link>
        </div>
        <form @submit.prevent="onSubmit"
              class="relative mauto">

          <!-- DETALII AUTO -->
          <div class="step step-1">
            <div class="flex align-center flex-between">
              <h2>
                <span class="number">1</span>
                {{ lang.autoDetails }}
              </h2>
            </div>

            <ul>
              <li v-for="(item, index) in auto"
                  :key="index">
                <validation-provider :rules="item.rules"
                                     v-slot="{ errors }">
                  <div class="input-group flex"
                       :class="{focus: item.model === activeField,
                                'invalid-input': errors[0]}"
                       :cy="`input-group-${item.model}`">
                    <label :for="item.model">{{ item.label }}</label>
                    <input :id="item.model"
                           :cy="item.model"
                           :ref="item.model"
                           v-model="data.car[item.model]"
                           class="uppercase"
                           @focus="handleCarFieldFocus($event, item.model)"
                           @blur="activeField = undefined"
                           @keyup="handleCarFieldInput($event, item.model)"
                           type="text"
                           placeholder="">
                  </div>
                </validation-provider>
              </li>
              <li>
                <textarea v-model="data.car.observatii"
                          name="observatii" placeholder="observații"></textarea>
              </li>
            </ul>
          </div>

          <!-- DETALII CLIENT -->
          <div class="step step-2">
            <h2>
              <span class="number">2</span>
              {{ lang.clientDetails }}
            </h2>

            <ul>
              <li v-for="(item, index) in client"
                  :key="index">
                <validation-provider :rules="item.rules"
                                     v-slot="{ errors }">
                  <div class="input-group flex"
                       :class="{focus: index === activeField,
                                    'invalid-input': errors[0]}"
                       :cy="`input-group-${item.model}`">
                    <label :for="item.model">{{ item.label }}</label>
                    <input :id="item.model"
                           :cy="item.model"
                           v-model="data.client[item.model]"
                           class="uppercase"
                           @focus="activeField = index"
                           @blur="activeField = undefined"
                           :type="item.type || 'text'"
                           :autocomplete="'as9dasd11' + item.model"
                           placeholder="">
                  </div>
                </validation-provider>
              </li>
            </ul>

          </div>

          <!-- DETALII REPARATII -->
          <div class="step step-3">
            <h2>
              <span class="number">3</span>
              {{ lang.repairsDetails }}
            </h2>

            <ul>
              <li>
                <span class="label">Defectiuni:</span>
                <div cy="defectiuni"
                     ref="defectiuni"
                     contenteditable="true"
                     v-html="data.comanda.defectiuni"></div>
              </li>
              <li>
                <span class="label">Piese client:</span>
                <div cy="piese-client"
                     ref="piese_client"
                     contenteditable="true"
                     v-html="data.comanda.piese_client"><div></div></div>
              </li>
            </ul>
          </div>

          <!-- PROGRAMARE -->
          <div class="step step-4">
            <h2 class="capitalize">
              <span class="number">4</span>
              {{ lang.programareNouaStepTitle }}
            </h2>

            <div class="programare-pickers">
              <div class="programare-picker-block">
                <IOSCalendar cy="booking-date"
                             :value="bookingDate"
                             disable-past
                             @input="bookingDate = $event" />
              </div>
              <div class="programare-picker-block">
                <IOSTimeGrid cy="booking-time"
                             :value="bookingTime"
                             :hours-label="lang.bookingHourLabel"
                             :minutes-label="lang.bookingMinuteLabel"
                             @input="bookingTime = $event" />
              </div>
            </div>

            <p class="programare-summary"
               cy="booking-summary"
               :class="{ 'programare-summary--empty': !bookingSummary }">
              {{ bookingSummary || lang.bookingSummaryEmpty }}
            </p>
          </div>

          <div class="actions flex">
            <button @click="anuleaza"
                    cy="cancel">
              {{ lang.quitBtn }}
            </button>
            <button class="flex-center"
                    cy="submit">
              {{ lang.saveBtn }}
            </button>
          </div>
        </form>
      </ValidationObserver>
    </main>
  </section>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import IOSCalendar from '../components/ios-picker/IOSCalendar.vue'
  import IOSTimeGrid from '../components/ios-picker/IOSTimeGrid.vue'
  import ProgramareNouaMobile from '../components/ProgramareNouaMobile.vue'
  export default {
    name: 'IntrareNoua',
    components: { IOSCalendar, IOSTimeGrid, ProgramareNouaMobile },
    data () {
      return {
        is_mobile: window.matchMedia('(max-width: 1024px)').matches,
        autocompleteFieldName: undefined,
        autocompletePositionY: 0,
        autocompletePositionX: 0,
        auto: [
          {
            label: 'Număr auto',
            model: 'numar',
            rules: 'required'
          },
          {
            label: 'Marcă',
            model: 'marca',
            rules: 'required'
          },
          {
            label: 'Model',
            model: 'model',
            rules: 'required'
          },
        ],
        client: [
          {
            label: 'Nume',
            model: 'nume',
            rules: 'required'
          },
          {
            label: 'Telefon',
            model: 'telefon',
            type: 'tel',
            rules: 'required'
          }
        ],
        activeField: undefined,
        autocompleteFields: [
          {
            field: 'numar',
            commit: 'FILTER_CAR_NUMBER'
          },
          {
            field: 'marca',
            commit: 'FILTER_CAR_BRAND'
          },
          {
            field: 'model',
            commit: 'FILTER_CAR_MODEL'
          }
        ],
        isAutocomplete: false
      }
    },
    created () {
      const id = this.$router.currentRoute.params.id
      if (!id) {
        this.$store.commit('RESET_FORMULAR_INTRARE_NOUA')
      }
      this.$store.dispatch('get_cars_numbers_templates')
      this.$store.dispatch('get_clienti')
      id && this.$store.dispatch('get_comanda', id)
      if (!this.bookingDate) {
        this.bookingDate = this.resolveInitialBookingDate()
      }
      this._mql = window.matchMedia('(max-width: 1024px)')
      this._mql_handler = (e) => { this.is_mobile = e.matches }
      this._mql.addEventListener('change', this._mql_handler)
    },
    beforeDestroy () {
      if (this._mql) this._mql.removeEventListener('change', this._mql_handler)
    },
    computed: {
      ...mapState({
        data: state => state.comenzi.comanda,
        clients_list: state => state.clienti.clienti
      }),
      ...mapGetters(['numar', 'marca', 'model', 'lang']),
      bookingDate: {
        get () {
          return this.data.booking_date || ''
        },
        set (value) {
          this.$store.commit('UPDATE_COMANDA_NOUA_FIELD', {key: 'booking_date', value})
        }
      },
      bookingTime: {
        get () {
          return this.data.booking_time || ''
        },
        set (value) {
          this.$store.commit('UPDATE_COMANDA_NOUA_FIELD', {key: 'booking_time', value})
        }
      },
      bookingSummary () {
        const date = this.bookingDate
        const time = this.bookingTime
        if (!date || !time) return ''
        const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(date)
        if (!m) return ''
        const y = +m[1]
        const mo = +m[2]
        const d = +m[3]
        const dt = new Date(y, mo - 1, d)
        if (isNaN(dt.getTime())) return ''
        const weekIdx = (dt.getDay() + 6) % 7
        const weekday = (this.lang.days?.[weekIdx] || '').toLowerCase()
        const monthShort = (this.lang.months?.[mo - 1] || '').slice(0, 3)
        return (this.lang.bookingSummary || '')
          .replace('{weekday}', weekday)
          .replace('{day}', d)
          .replace('{month}', monthShort)
          .replace('{time}', time)
      }
    },
    methods: {
      async onSubmit () {
        const observer = this.$refs.observer
        const valid = observer ? await observer.validate() : true
        if (!valid) {
          this.$nextTick(() => this._scrollToFirstInvalid())
          return
        }
        this.submit()
      },
      _scrollToFirstInvalid () {
        const root = this.$el
        if (!root) return
        const first = root.querySelector('.invalid-input')
        if (!first) return
        if (typeof first.scrollIntoView === 'function') {
          first.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }
        const input = first.querySelector('input, textarea')
        if (input && typeof input.focus === 'function') {
          setTimeout(() => input.focus({ preventScroll: true }), 300)
        }
      },
      submit () {
        const fields = ['cerinte_client', 'defectiuni', 'piese_client']
        fields.forEach((key) => {
          const htmlVal = this.$refs[key]?.innerHTML
          this.$store.commit('UPDATE_COMANDA_HTML_FIELD', {key, htmlVal})
        })
        if (this.data._id) {
          this.$store.dispatch('update_comanda', this.data._id)
        }
        else {
          this.data.status = 0
          this.$store.dispatch('create_programare', this.data);
        }
      },
      anuleaza () {
        this.$store.commit('SET_KEY_VALUE', { key: 'comanda', value: {} })
        this.$router.push('/programari')
      },
      handleAutocompleteItem ({name, value}) {
        if (name === 'numar') {
          const details = this.$store.state.templates.carsNumbers
              .filter(o => o.numar === value)[0]
          this.$store.commit('SET_CAR_DETAILS', details)
          const clientDetails = details && details.client_id &&
            this.clients_list.find(c => c._id === details.client_id)
          if (clientDetails) {
            this.$store.commit('SET_CLIENT_FIELD_VALUE', { name: 'nume', value: clientDetails.nume || '' })
            this.$store.commit('SET_CLIENT_FIELD_VALUE', { name: 'telefon', value: clientDetails.telefon || '' })
          }
        } else {
          this.$store.commit('SET_CAR_FIELD_VALUE', {name, value})
        }
        this.isAutocomplete = false
        const elmIndex = this.auto.findIndex(o => o.model === name)
        setTimeout(() => {
          const index = name === 'numar' ? elmIndex + 4 : elmIndex + 1
          this.$refs[this.auto[index]?.model]?.[0]?.focus()
        }, 0)
        name === 'marca' && this.$store.commit('SET_CARS_MODELS', value)
      },
      handleCarFieldFocus ({target}, fieldName) {
        this.activeField = fieldName
        const section = this.autocompleteFields.filter(o => o.field === fieldName)
        this.isAutocomplete = !!section.length
        this.autocompleteFieldName = fieldName
        this.autocompletePositionY = target.offsetTop + 39
        this.autocompletePositionX = target.offsetLeft + 16
      },
      handleCarFieldInput ({key}, fieldName) {
        if (this.isAutocomplete) {
          const section = this.autocompleteFields.filter(o => o.field === fieldName)[0]
          const value = this.data.car[fieldName] || ''
          const a_z = !!key && /[0-9a-zA-Z]/.test(key) && key.length === 1
          switch (key) {
            case 'Backspace':
              this.$store.commit(section.commit, value.toLowerCase())
              break
            default:
              !!value && a_z && this.$store.commit(section.commit, value.toLowerCase())
          }
        }
      },
      hideAutocomplete () {
        this.isAutocomplete = false
      },
      resolveInitialBookingDate () {
        const queryDate = this.$router.currentRoute.query.date
        if (/^\d{4}-\d{2}-\d{2}$/.test(queryDate)) return queryDate
        const t = new Date()
        return `${t.getFullYear()}-${String(t.getMonth() + 1).padStart(2, '0')}-${String(t.getDate()).padStart(2, '0')}`
      }
    },
    destroyed () {
      this.$store.commit('RESET_FORMULAR_INTRARE_NOUA')
    },
    watch: {
      $route(to) {
        !to.params.id && this.$store.commit('RESET_FORMULAR_INTRARE_NOUA')
      }
    }
  }
</script>

<style lang="less">
  @import "../styles/var";
  .intrare-noua {
    @media only screen and (min-width: 0) {
      min-height: 100%;
      background-color: @gray;
      padding: 76px 10px 0;

      main {
        width: 100%;
        max-width: 750px;
        margin: 0 auto;
        padding-bottom: 100px;
      }
      .number {
        padding: 0 20px;
        font-size: 3.8rem;
        font-family: "Avenir-Black", sans-serif!important;
      }
      h2 {
        font-size: 2rem;
      }

      form {
        ul {
          padding: 0 16px;
        }
        input {
          width: 100%;
          height: 38px;
          border-radius: var(--border-radius);
          padding-left: 16px;
          font-size: 1.8rem;
          background-color: transparent;
          font-weight: bold;
        }
        textarea {
          width: 100%;
          height: 100px;
          resize: none;
          box-sizing: border-box;
          border: none;
          font-size: 1.8rem;
          padding-left: 10px;
          padding-top: 10px;
        }
        .input-group {
          width: 100%;
          margin-bottom: 1px;
          background-color: white;
          transition: background-color .15s ease, box-shadow .15s ease;
          label {
            width: 190px;
            padding-top: 8px;
            padding-left: 12px;
            font-size: 1.8rem;
          }
        }
        .focus {
          background-color: #F2F7FF;
          box-shadow: inset 3px 0 0 0 var(--blue);
        }
      }

      .step {
        padding: 4px 0 80px 0;
      }
      .step.step-4 {
        padding-bottom: 30px;
      }
      .top-actions {
        display: flex;
        position: absolute;
        top: 20px;
        right: 0;
        z-index: 9;
        a {
          cursor: pointer;
          display: inline-block;
        }
        button {
          border: none;
          padding: 8px 20px;
          font-size: 1.6rem;
          font-weight: bold;
          border-radius: var(--border-radius);
          color: white;
          transition: background-color .1s ease-in-out;
          &:first-child {
            margin-right: 20px;
            background-color: var(--blue);
            &:hover {
              background-color: darken(#29abe2, 20%, relative)!important;
            }
          }
          &:last-child {
            background-color: var(--orange);
            &:hover {
              background-color: darken(#f7931e, 20%, relative)!important;
            }
          }
        }
      }

      .step-1 > div:first-child {
        padding-right: 0px;
      }
      span.label {
        margin-bottom: 4px;
        display: block;
        font-size: 1.6rem;
        color: black;
      }
      .step-1, .step-3 {
        background-color: #3E3D3E;
        h2 {
          color: white;
        }
      }

      .step-2 {
        background-color: #d6d6d6;
        .number {
          color: @dark-gray;
        }
      }

      .step-3 {
        background-color: var(--red);
        span.label {
          color: white;
        }
      }

      .step-4 {
        background-color: #F2F2F7;
        h2 {
          color: @dark-gray;
        }
        .number {
          color: @dark-gray;
        }
        span.label {
          color: white;
        }
        .programare-pickers {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          align-items: flex-start;
          justify-content: center;
          gap: 20px;
          width: 100%;
          max-width: 900px;
          margin: 0 auto;
          padding: 0 16px;
          box-sizing: border-box;
        }
        .programare-picker-block {
          display: flex;
          flex-direction: column;
          gap: 8px;
          min-width: 0;
          flex: 0 1 auto;
          width: 100%;
          max-width: 340px;
        }
        .programare-picker-block:first-child {
          max-width: 320px;
        }
        .programare-picker-block:last-child {
          max-width: 285px;
        }
        .programare-picker-block label {
          font-size: 1.8rem;
          padding-bottom: 4px;
          color: @dark-gray;
        }
        .programare-summary {
          margin: 25px auto 0;
          max-width: 780px;
          padding: 12px 16px;
          text-align: center;
          font-size: 1.8rem;
          font-weight: 600;
          color: @dark-gray;
          background: #FFFFFF;
          border-radius: 0;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 4px 12px rgba(0, 0, 0, 0.04);
        }
        .programare-summary--empty {
          font-weight: 400;
          color: rgba(60, 60, 67, 0.55);
          background: transparent;
          box-shadow: none;
        }
      }

      .invalid-input {
        border: none!important;
        label {
          color: red;
        }
      }

      .actions {
        margin-top: 20px;
        //justify-content: center;
        button {
          height: 40px;
          padding: 0 20px;
          font-size: 2rem;
          border-radius: var(--border-radius);
          font-weight: bold;
          &:first-child {
            margin-right: 30px;
            background-color: @light-gray;
            transition: background-color .1s ease-in-out;
            &:hover {
              background-color: darken(@light-gray, 20%, relative)!important;
            }
          }
          &:last-child {
            color: white;
            background-color: @dark-green;
            transition: background-color .1s ease-in-out;
            &:hover {
              background-color: darken(@dark-green, 20%, relative)!important;
            }
          }
        }
      }
      div[contenteditable] {
        min-height: 80px;
        margin-bottom: 8px;
        padding: 8px;
        background-color: white;
        font-size: 1.6rem;
        > div:first-child {
          min-height: 20px;
          line-height: 16px;
        }
      }
    }

    @media only screen and (max-width: 1023px) {
      .step-4 {
        .programare-pickers {
          flex-direction: column;
          align-items: center;
          gap: 16px;
          padding: 0 12px;
        }
        .programare-picker-block:first-child {
          width: 100%;
          max-width: 340px;
        }
        .programare-picker-block:last-child {
          width: 100%;
          max-width: 340px;
        }
        .programare-summary {
          margin: 18px auto 0;
          max-width: 340px;
          font-size: 1.6rem;
          padding: 10px 14px;
          border-radius: 14px;
        }
      }
      .actions {
        justify-content: flex-end;
        padding-right: 16px;
      }
    }
    @media only screen and (max-width: 380px) {
      .step-4 {
        .programare-pickers {
          gap: 14px;
          padding: 0 8px;
        }
        .programare-summary {
          margin: 14px auto 0;
          max-width: 330px;
          font-size: 1.5rem;
          padding: 10px 12px;
        }
      }
    }

    @media only screen and (max-width: 1024px) {
      main {
        overflow: scroll;
      }
    }

    @media only screen and (min-width: 1024px) {
      main {
        margin: 40px auto 0;
        .step-1 > div:first-child {
          padding-right: 40px;
        }
      }
      form {
        ul {
          padding: 0 67px;
        }
      }
      .actions {
        button {
          &:first-child {
            margin-left: auto;
          }
        }
      }
    }
  }
</style>
